import { EvkHttpService, EvkUpdateServiceBase } from '@evomatik/evk-common';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EvkDiligenciaAutorizarService extends EvkUpdateServiceBase<any> {

    constructor(h: EvkHttpService) {
        super(h);
    }

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2/autorizar';
    }

    evkOnBeforeEdit(data: any): Observable<any> {
        return new Observable<any>(subscriber => subscriber.next(data));
    }

    evkOnDoneEdit(response: any): void {
    }

    evkOnErrorEdit(error: any): void {
    }

}
